import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { JSX, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Keyboard, Mousewheel, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import BannerAnimatedContent from "../../Components/BannerAnimatedContent";
import HomeSecondSetion from "../../Components/HomeSecondSetion";
import ContactUs from "../../Components/Popup/ContactUs";
import imagePath from "../../constants/imagePath";
import {
  Access,
  AdobIllustrator,
  Adobxd,
  AgileProcess,
  Android,
  Angular,
  API,
  Appium,
  ApplicationDevelopment,
  Appointment,
  AWS,
  AxureRp,
  AzureDevOps,
  AzureSql,
  Balsamiq,
  BannerArrow,
  BannerArrowBtm,
  Booking,
  Bootstrap,
  BorderImage,
  Budget,
  BusinessAutomation,
  BusinessFocused,
  CiPipelines,
  CircleCheck,
  Cloud,
  Cloud2,
  Conceptualizing,
  CoreTeam,
  CredibleSupport,
  CSS,
  CustomizedSolutions,
  Cypress,
  Devops,
  DigitalOcean,
  DigitalTransformation,
  Docker,
  DotNet,
  Ecommerce2,
  ECommerceDevelopment,
  Expertise,
  ExtensiveMetaverse,
  Figma,
  Firestore,
  Flutter,
  Framer,
  GCP,
  GO,
  HighEndServices,
  HomeService,
  Html,
  InVision,
  Ionic,
  IOS,
  JAVA,
  Jenkins,
  Kubernetes,
  Magneto,
  Marketing,
  Maze,
  MongoDB,
  MYSQL,
  NextJS,
  NodeJS,
  OnDemand2,
  OnDemand3,
  OnTimeDelivery,
  OracleCloud,
  PHP,
  Playwright,
  PostgreSQL,
  Postman,
  PPC,
  ProfoundRD,
  ProjectDevelopment,
  PWA,
  Python,
  Rackspace,
  ReactNativeIcon,
  Redis,
  RigorousTesting,
  Selenium,
  SEO,
  Shopify,
  Sketch,
  SMM,
  SMO,
  SQLite,
  Staff,
  StartIocn,
  Swagger,
  TechnicalMaintenance,
  Typescript,
  Understanding,
  Vuejs,
  XCTest,
} from "../../constants/svgPath";
import { EngineeringData } from "../../utils/ServiceData";

gsap.registerPlugin(ScrollTrigger);

interface IconType {
  name: string;
  icon: JSX.Element;
}

interface servicelink {
  slug: string;
  link: string;
}

interface ServiceType {
  title: string;
  icon: JSX.Element;
  description: string;
  image: string;
  links: servicelink[];
  icons: IconType[];
}
const awardsData = [
  {
    img: imagePath.AwardsOne,
    title: "Top web design",
    titlebr: "company",
    subtitle: "DesignRush, 2024",
  },
  {
    img: imagePath.Awardssecnd,
    title: "Top B2B company",
    titlebr: "company",
    subtitle: "Clutch, 2024",
  },
  {
    img: imagePath.Awardsthrd,
    title: "Top App Development ",
    titlebr: "company",
    subtitle: "Business Outlook, 2024",
  },
  {
    img: imagePath.Awardsfr,
    title: "Top 10 places ",
    titlebr: "to work",
    subtitle: "TET, 2024",
  },
];
const SuccessData = [
  { icon: "⚙️", title: "Frontend" },
  { icon: "🖥️", title: "Backend" },
  { icon: "📱", title: "Mobile" },
  { icon: "💾", title: "Databases" },
  { icon: "🧩", title: "Frameworks" },
];
// const EngineeringData = [
//   {
//     id: 1,
//     icon: <Finance />,
//     title: "Finance/Banking",
//     image: imagePath.Engimg,
//     subtitle: "Banking-Financial Services and Insurance",
//     description:
//       "We deliver secure, intelligent, and scalable solutions for banks, financial institutions, and insurance companies. Our platforms combine cutting-edge technology, robust security, and seamless user experiences to streamline operations, enhance customer engagement, and enable data-driven decision-making.",
//     highlights: [
//       "Financial Software Development Services",
//       "Account and Cashflow Management",
//       "Investment and Portfolio Management",
//       "Budgeting and Forecasting",
//       "Tax Management",
//       "Insurance Management",
//     ],
//   },
//   {
//     id: 2,
//     icon: <HealthcareIcon />,
//     title: "Healthcare",
//     image: imagePath.health_care,
//     subtitle: "",
//     description:
//       "We create innovative and secure healthcare solutions that empower users to manage wellness, track health goals, and access essential medical services with ease. From fitness and lifestyle applications to advanced digital health platforms, we combine smart technology, seamless user experiences, and reliable data handling to build scalable systems that support better health outcomes, stronger engagement, and long-term well-being.",
//     highlights: [
//       "Custom Healthcare Software Development",
//       "Healthcare App Development",
//       "Doctor Appointment App Development",
//       "Fitness App Development Company",
//     ],
//   },
//   {
//     id: 3,
//     icon: <Education />,
//     title: "Education",
//     image: imagePath.education,
//     subtitle: "",
//     description:
//       "We develop innovative and engaging education solutions that make learning accessible, interactive, and effective. From feature-rich education apps to comprehensive eLearning software, we combine modern technology, intuitive design, and scalable architecture to create platforms that enhance student engagement, streamline administration, and support lifelong learning.",
//     highlights: ["Education App Development", "eLearning Software Development"],
//   },
//   {
//     id: 4,
//     icon: <Logistics />,
//     title: "Logistics",
//     image: imagePath.logistics,
//     subtitle: "",
//     description:
//       "We deliver logistics technology solutions that help businesses optimize operations, enhance delivery accuracy, and achieve end-to-end supply chain visibility. We combine smart automation, real-time tracking, and robust data intelligence to build scalable systems that improve efficiency, reduce operational costs, and ensure seamless movement of goods from source to destination.",
//     highlights: [
//       "Logistics App Development",
//       "Logistics Software Development",
//       "Supply Chain Software Development",
//       "Inventory Management",
//       "Fleet Management",
//     ],
//   },
//   {
//     id: 5,
//     icon: <OnDemand />,
//     title: "On-demand",
//     image: imagePath.on_demand,
//     subtitle: "",
//     description:
//       "We develop high-performance on-demand solutions that connect users with services in real time. From booking and delivery to live streaming and appointments, we combine intuitive design, secure technology, and scalable architecture to create platforms that enhance user convenience, improve operational efficiency, and drive long-term business growth.",
//     highlights: [
//       "Taxi App Development",
//       "Food and Grocery Delivery App Development",
//       "Live Streaming App Development",
//       "Car Wash App Development",
//       "Beauty Salon App Development",
//       "Restaurant App Development",
//       "Hotel Booking App Development",
//     ],
//   },
//   {
//     id: 6,
//     icon: <TravelHospitality />,
//     title: "Travel",
//     image: imagePath.travel,
//     subtitle: "",
//     description:
//       "We build innovative travel and hospitality solutions that deliver seamless booking experiences, real-time updates, and personalized journeys for users. From travel apps to hotel management platforms, we combine modern technology, intuitive design, and scalable systems to enhance customer engagement, streamline operations, and drive long-term growth in the travel and hospitality sector.",
//     highlights: ["Travel App Development", "Hotel App Development"],
//   },
//   {
//     id: 7,
//     icon: <RealEstate />,
//     title: "Real Estate",
//     image: imagePath.real_estate,
//     subtitle: "",
//     description:
//       "We develop innovative real estate solutions that simplify property management, streamline transactions, and enhance user engagement. From property search and listing platforms to agent and management apps, we combine modern design, secure technology, and seamless functionality to deliver scalable solutions that empower buyers, sellers, and agents alike.",
//     highlights: [
//       "Real Estate Agent Apps",
//       "Property Listing and Search Apps",
//       "Property Management Apps",
//     ],
//   },
//   {
//     id: 8,
//     icon: <EcommerceSlider />,
//     title: "eCommerce",
//     image: imagePath.ecommerce,
//     subtitle: "",
//     description:
//       "We build robust, scalable, and user-friendly eCommerce solutions that drive sales and enhance customer engagement. By combining modern design, secure technology, and optimized performance, we create web and mobile stores that deliver seamless shopping experiences, streamline operations, and support long-term business growth.",
//     highlights: [
//       "eCommerce Website Development",
//       "eCommerce App Development",
//       "Magento eCommerce Development",
//       "Shopify Development Services",
//       "eCommerce SEO Services",
//     ],
//   },

//   {
//     id: 9,
//     icon: <MediaEntertainment2 />,
//     title: "Media & Entertainment",
//     image: imagePath.media_entertainment,
//     subtitle: "",
//     description:
//       "We deliver innovative media and entertainment solutions that engage audiences, drive user interaction, and enhance content delivery across platforms. From social media apps and music streaming to video-on-demand and OTT platforms, we combine modern design, scalable technology, and seamless performance to build apps that entertain, inspire, and keep users coming back.",
//     highlights: [
//       "Social Media App Development",
//       "Video Streaming App Development",
//       "Roku TV App Development",
//       "Smart TV App Development",
//       "Music Streaming App Development",
//       "Entertainment App Development",
//       "OTT App Development",
//     ],
//   },

//   {
//     id: 10,
//     icon: <Government />,
//     title: "Government",
//     image: imagePath.government,
//     subtitle: "",
//     description:
//       "We develop intelligent, secure, and scalable solutions for government organizations to enhance efficiency, transparency, and decision-making. From ERP systems to predictive planning tools, our platforms leverage modern technology, data-driven insights, and seamless workflows to optimize operations, improve citizen services, and drive sustainable growth in the public sector.",
//     highlights: [
//       "ERP Software Development",
//       "Intelligent Asset Management",
//       "Smart Procurement & Contracts Management",
//       "Supplier Management Software Development",
//       "Predictive Budgeting & Planning",
//       "Capital Planning Software Development",
//     ],
//   },
//   {
//     id: 11,
//     icon: <Automotive />,
//     title: "Automotive (Auto-Mobile)",
//     image: imagePath.automotive,
//     subtitle: "",
//     description:
//       "We deliver innovative and scalable automotive solutions that drive efficiency, connectivity, and enhanced user experiences. From vehicle management systems to connected car applications, we combine cutting-edge technology, real-time data, and intuitive design to create platforms that optimize operations, improve customer engagement, and support growth in the automotive industry.",
//     highlights: [
//       "Vehicle Tracking & Telematics Systems",
//       "EV & Charging Station Management Apps",
//       "Automotive IoT Integrations",
//       "Automobile Sales & Dealership Platforms",
//       "Fleet Management Solutions",
//       "Connected Vehicle App Development",
//     ],
//   },

//   {
//     id: 12,
//     icon: <Fintech />,
//     title: "Fintech",
//     image: imagePath.fintech,
//     subtitle: "",
//     description:
//       "We craft secure, intelligent, and high-performance financial technology solutions that empower businesses and users to manage money, investments, and payments with ease. From digital wallets to investment platforms and payment gateways, our solutions combine cutting-edge technology, seamless experiences, and robust analytics to drive efficiency, compliance, and growth in the fast-evolving financial sector.",
//     highlights: [
//       "Digital Banking & Wallet Solutions",
//       "Payment Gateway Integration",
//       "Investment & Portfolio Management Platforms",
//       "Loan & Credit Management Systems",
//       "Risk & Compliance Solutions",
//       "Trading & Wealth Management Applications",
//     ],
//   },

//   {
//     id: 13,
//     icon: <Sports />,
//     title: "Sports",
//     image: imagePath.sports,
//     subtitle: "",
//     description:
//       "We develop dynamic, engaging, and high-performance sports solutions that connect athletes, fans, and organizations. From fitness tracking apps to event management platforms and fan engagement tools, our solutions combine real-time data, intuitive design, and seamless performance to enhance participation, improve performance tracking, and deliver immersive experiences across the sports ecosystem.",
//     highlights: [
//       "Fitness & Training App Development",
//       "Sports Event Management Platforms",
//       "Fan Engagement & Ticketing Apps",
//       "Fleet Management Solutions",
//       "Fantasy Sports & Gaming Platforms",
//       "Wearable Sports Device Integrations",
//     ],
//   },
// ];

const stackItems = [
  "UI/UX",
  "Frontend",
  "Mobile",
  "Backend",
  "Database",
  "DevOps",
  "Quality Assurance",
  "Cloud DB",
];

const uiUXStackIcons = [
  { icon: <Figma />, title: "Figma" },
  { icon: <Adobxd />, title: "Adobe XD" },
  { icon: <AdobIllustrator />, title: "Adobe Illustrator" },
  { icon: <InVision />, title: "InVision" },
  { icon: <AxureRp />, title: "Axure RP" },
  { icon: <Maze />, title: "Maze" },
  { icon: <Sketch />, title: "Sketch" },
  { icon: <Framer />, title: "Framer" },
  { icon: <Balsamiq />, title: "Balsamiq" },
];

const webStackIcons = [
  { icon: <ReactNativeIcon />, title: "React.JS" },
  { icon: <NextJS />, title: "Next.JS" },
  { icon: <Vuejs />, title: "Vue.js" },
  { icon: <Angular />, title: "AngularJS" },
  { icon: <CSS />, title: "CSS3" },
  { icon: <Html />, title: "HTML5" },
  { icon: <Typescript />, title: "TypeScript" },
  { icon: <Bootstrap />, title: "Bootstrap" },
];

const mobileStackIcons = [
  { icon: <ReactNativeIcon />, title: "React Native" },
  { icon: <Flutter />, title: "Flutter" },
  { icon: <IOS />, title: "iOS" },
  { icon: <Android />, title: "Android" },
  { icon: <Ionic />, title: "Ionic" },
  { icon: <PWA />, title: "PWA" },
];

const backendStackIcons = [
  { icon: <PHP />, title: "PHP" },
  { icon: <NodeJS />, title: "Node.js" },
  { icon: <Python />, title: "Python" },
  { icon: <DotNet />, title: ".NET" },
  { icon: <JAVA />, title: "Java" },
  { icon: <GO />, title: "Go" },
];

const databaseStackIcons = [
  { icon: <MYSQL />, title: "MySQL" },
  { icon: <MongoDB />, title: "MongoDB" },
  { icon: <Firestore />, title: "Firebase Firestore" },
  { icon: <SQLite />, title: "SQLite" },
  { icon: <Redis />, title: "Redis" },
  { icon: <PostgreSQL />, title: "PostgreSQL" },
];

const devopsStackIcons = [
  { icon: <Kubernetes />, title: "Kubernetes" },
  { icon: <Docker />, title: "Docker" },
  { icon: <Jenkins />, title: "Jenkins" },
  { icon: <AzureDevOps />, title: "Azure DevOps" },
  { icon: <CiPipelines />, title: "CI CD Pipelines" },
  { icon: <AWS />, title: "AWS" },
  { icon: <GCP />, title: "GCP" },
];

const qualityAssuranceStackIcons = [
  { icon: <Selenium />, title: "Selenium" },
  { icon: <Cypress />, title: "Cypress" },
  { icon: <XCTest />, title: "XCTest / XCUITest" },
  { icon: <Appium />, title: "Appium" },
  { icon: <Playwright />, title: "Playwright" },
  { icon: <Postman />, title: "Postman" },
  { icon: <Swagger />, title: "Swagger / OpenAPI" },
];

const cloudDBStackIcons = [
  { icon: <GCP />, title: "Google Cloud SQL" },
  { icon: <AWS />, title: "Amazon RDS" },
  { icon: <AzureSql />, title: "Azure SQL" },
  { icon: <AWS />, title: "Amazon Aurora" },
  { icon: <OracleCloud />, title: "Oracle Cloud" },
  { icon: <DigitalOcean />, title: "DigitalOcean" },
  { icon: <Rackspace />, title: "Rackspace" },
];

export default function Home() {
  const activeTabRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [selectTechStackItem, setSelectTechStackItem] = useState("UI/UX");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectEngItem, setSelectEngItem] = useState(EngineeringData[0]);

  const services: ServiceType[] = [
    {
      title: "Mobile App Development",
      icon: <ApplicationDevelopment />,
      description:
        "We provide full-cycle mobile app development, delivering secure, scalable solutions aligned with business goals. We build intuitive, high-performance apps across platforms, ensuring reliability and seamless functionality.",
      image: imagePath.NextSection,
      links: [
        {
          link: "iOS App Development",
          slug: "ios-app-development",
        },
        {
          link: "Android App Development",
          slug: "android-app-development",
        },
        {
          link: "Cross-Platform App Development",
          slug: "cross-platform-app-development",
        },
        {
          link: "React Native App Development",
          slug: "react-native-app-development",
        },
        {
          link: "Flutter App Development",
          slug: "flutter-app-development",
        },
        {
          link: "Ionic App Development",
          slug: "ionic-app-development",
        },
        {
          link: "Progressive Web App (PWA) Development",
          slug: "progressive-web-app-development",
        },
        {
          link: "Wearable App Development",
          slug: "wearable-app-development",
        },
      ],

      icons: [
        { name: "", icon: <Android /> },
        { name: "", icon: <IOS /> },
        { name: "", icon: <ReactNativeIcon /> },
        { name: "", icon: <Flutter /> },
        { name: "", icon: <Ionic /> },
      ],
    },
    {
      title: "eCommerce Development",
      icon: <ECommerceDevelopment />,
      description:
        "We deliver eCommerce development services helping brands create seamless online stores that convert. Using design, technology, and optimized performance, we build scalable platforms driving growth.",
      image: imagePath.eCommerce_development,
      links: [
        {
          link: "eCommerce Website Development",
          slug: "ecommerce-website-development",
        },
        {
          link: "eCommerce App Development",
          slug: "ecommerce-app-development",
        },
        {
          link: "Magento eCommerce Development",
          slug: "magento-ecommerce-development",
        },
        {
          link: "Shopify Development Services",
          slug: "shopify-development-services",
        },
        {
          link: "eCommerce SEO Services",
          slug: "search-engine-optimization-seo",
        },
      ],
      icons: [
        { name: "", icon: <Shopify /> },
        { name: "", icon: <SEO /> },
        { name: "", icon: <Magneto /> },
        { name: "", icon: <Ecommerce2 /> },
      ],
    },
    {
      title: "On-Demand App Development",
      icon: <OnDemand2 />,
      description:
        "We provide on-demand app development services to deliver fast, real-time experiences across service categories. We use modern design and secure architecture to build reliable, high-performance platforms that improve efficiency and scalability.",
      image: imagePath.on_demand_app_Development,
      links: [
        {
          link: "Appointment App Development",
          slug: "appointment-app-development",
        },
        {
          link: "Booking System Development",
          slug: "booking-system-development",
        },
        {
          link: "On-Demand Delivery App Development",
          slug: "on-demand-delivery-app-development",
        },
        {
          link: "Home Service Development",
          slug: "home-service-app-development",
        },
      ],
      icons: [
        { name: "", icon: <Booking /> },
        { name: "", icon: <Appointment /> },
        { name: "", icon: <HomeService /> },
        { name: "", icon: <OnDemand3 /> },
      ],
    },
    {
      title: "Digital Marketing",
      icon: <DigitalTransformation />,
      description:
        "We help brands grow their online presence through strategic digital marketing. We use data insights, creative content, and optimization to boost visibility, attract target audiences, and increase conversions across digital channels.",
      image: imagePath.digital_marketing,
      links: [
        {
          link: "Search Engine Optimization (SEO)",
          slug: "digital-marketing-seo",
        },
        {
          link: "Pay Per Click (PPC)",
          slug: "digital-marketing-ppc",
        },
        {
          link: "Online Reputation Management (ORM)",
          slug: "digital-marketing-orm",
        },
        {
          link: "Social Media Optimization (SMO)",
          slug: "digital-marketing-smo",
        },
        {
          link: "Social Media Marketing (SMM)",
          slug: "digital-marketing-smm",
        },
      ],
      icons: [
        { name: "", icon: <PPC /> },
        { name: "", icon: <SMO /> },
        { name: "", icon: <Marketing /> },
        { name: "", icon: <SMM /> },
      ],
    },
    {
      title: "Cloud Engineering",
      icon: <Cloud />,
      description:
        "We provide DevOps services to streamline development, deployment, and operations through faster delivery, improved reliability, and automation. We use CI/CD pipelines, cloud tools, and monitoring to build scalable, secure workflows.",
      image: imagePath.cloud_engineering,
      links: [
        {
          link: "DevOps Consulting",
          slug: "devops-consulting",
        },
        {
          link: "CI/CD Pipeline Development",
          slug: "ci-cd-pipeline-development",
        },
        {
          link: "Infrastructure as Code (IaC)",
          slug: "infrastructure-as-code-iac",
        },
        {
          link: "Cloud Migration & Management",
          slug: "cloud-migration-management",
        },
        {
          link: "Containerization & Orchestration",
          slug: "containerization-orchestration",
        },
        {
          link: "Microservices Architecture Setup",
          slug: "microservices-architecture-setup",
        },
        {
          link: "Site Reliability Engineering (SRE)",
          slug: "site-reliability-engineering-sre",
        },
      ],
      icons: [
        { name: "", icon: <API /> },
        { name: "", icon: <Devops /> },
        { name: "", icon: <Cloud2 /> },
        // { name: "", icon: <CloudLock /> },
      ],
    },
    {
      title: "Product Engineering",
      icon: <BusinessAutomation />,
      description:
        "We provide product engineering services to design, build, and scale digital products from concept to launch. We use agile methods and user-focused design to deliver reliable products that drive growth.",
      image: imagePath.product_engineering,
      links: [
        {
          link: "MVP Development",
          slug: "mvp-development",
        },
        {
          link: "Product Design & Prototyping",
          slug: "product-design-prototyping",
        },
        {
          link: "Full-Scale Product Development",
          slug: "full-scale-product-development",
        },
        {
          link: "Product Modernization & Optimization",
          slug: "product-modernization-optimization",
        },
        {
          link: "Product Testing & QA",
          slug: "product-testing-qa",
        },
      ],
      icons: [],
    },

    {
      title: "Staff Augmentation",
      icon: <Staff />,
      description:
        "Need extra hands on your team? Our staff augmentation service lets you bring in skilled professionals whenever you need them. We help you fill gaps, add expertise, and keep your projects moving without slowing down.",
      image: imagePath.staff_augmentation,
      links: [
        {
          link: "IT Staffing Solutions",
          slug: "it-staffing-solutions",
        },
        {
          link: "On-Demand Expertise",
          slug: "on-demand-expertise",
        },
        {
          link: "Skills Gap Analysis",
          slug: "skills-gap-analysis",
        },
        {
          link: "Project-Based Augmentation",
          slug: "project-based-augmentation",
        },
        {
          link: "Team Expansion",
          slug: "team-expansion",
        },
      ],
      icons: [],
    },
    // ...baaki list yahan add kar sakte ho
  ];

  const handleClick = (index: number) => {
    sessionStorage.setItem("active_service", JSON.stringify(index));
    setActiveIndex(index);
  };

  const activeService = services[activeIndex];
  useEffect(() => {
    const counters = document.querySelectorAll(".cont_child h3");

    // Sab counters ko initially 0 pe reset karo
    counters.forEach((counter) => {
      const el = counter as HTMLElement;
      const suffix = el.innerText.replace(/[0-9]/g, "");
      el.innerText = "0" + suffix;
    });

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".banner",
        start: "top 80%",
        end: "bottom 60%",
        scrub: false,
        markers: false,
      },
    });

    tl.from(".banner_left h1", {
      y: 50,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
    })
      .from(
        ".banner_txt",
        {
          y: 30,
          opacity: 0,
          duration: 0.8,
          ease: "power2.out",
        },
        "-=0.5",
      )
      .from(
        ".btn_common",
        {
          scale: 0.8,
          opacity: 0,
          duration: 0.6,
          ease: "back.out(1.7)",
        },
        "-=0.3",
      )
      .from(
        ".cont_child",
        {
          y: 40,
          opacity: 0,
          stagger: 0.2,
          duration: 0.8,
          ease: "power2.out",
        },
        "-=0.4",
      );

    // ✅ Counter animation: all together
    const obj = { val: 0 }; // single object for animation
    tl.to(
      obj,
      {
        val: 1, // dummy value, we'll calculate individual counts in onUpdate
        duration: 2,
        ease: "power1.out",
        onUpdate: () => {
          counters.forEach((counter) => {
            const el = counter as HTMLElement;
            const finalValue = parseInt(
              el.dataset.value || el.innerText.replace(/[^\d]/g, ""),
            );
            const suffix = el.innerText.replace(/[0-9]/g, "");
            const progress = obj.val; // 0 → 1
            el.innerText = Math.floor(progress * finalValue) + suffix;
          });
        },
      },
      "-=0.3",
    ); // overlap with previous animation

    return () => {
      tl.kill();
    };
  }, []);

  useEffect(() => {
    const active_serivce = sessionStorage.getItem("active_service");
    setActiveIndex(Number(active_serivce));

    const path = document.querySelector(".our_path") as SVGPathElement | null;

    if (path) {
      const length = path.getTotalLength();

      // Hide stroke initially
      path.style.strokeDasharray = `${length}`;
      path.style.strokeDashoffset = `${length}`;

      // Animate as user scrolls through .our_sec
      gsap.to(path, {
        strokeDashoffset: 0,
        ease: "none",
        scrollTrigger: {
          trigger: ".our_sec", // ab pura section trigger hai
          start: "top center", // jab section viewport ke center me aaye tab start
          end: "bottom center", // jab section bottom viewport ke center me ho tab complete
          scrub: true, // scroll ke sath smooth draw
        },
      });
    }
  }, []);
  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isPopupOpen) {
      document.body.classList.add("body_active");
    } else {
      document.body.classList.remove("body_active");
    }
  }, [isPopupOpen]);

  const getTechChildStackItems = () => {
    switch (selectTechStackItem) {
      case "UI/UX":
        return uiUXStackIcons;
      case "Frontend":
        return webStackIcons;
      case "Mobile":
        return mobileStackIcons;
      case "Backend":
        return backendStackIcons;
      case "Database":
        return databaseStackIcons;
      case "DevOps":
        return devopsStackIcons;
      case "Quality Assurance":
        return qualityAssuranceStackIcons;
      case "Cloud DB":
        return cloudDBStackIcons;
      default:
        return uiUXStackIcons;
    }
  };

  return (
    <>
      <section className="banner">
        <div className="contair banner_con">
          <div className="banner_left">
            <BannerAnimatedContent />
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              Consult Our Experts
            </button>
            <div className="count">
              <div className="cont_child">
                <h3 data-value="15">15+</h3>
                <p>Successful Client Engagements</p>
                <span>
                  <BorderImage />
                </span>
              </div>
              <div className="cont_child">
                <h3 data-value="5">5+ years</h3>
                <p>Experience Building Mobile & Web Solutions</p>
                <span>
                  <BorderImage />
                </span>
              </div>

              <div className="cont_child">
                <h3 data-value="100">100%</h3>
                <p>Commitment to Quality & On-Time Delivery</p>
              </div>
            </div>
          </div>
          <div className="banner_r">
            <div className="banner_cart bnnr_top">
              <span>
                <BannerArrow />
              </span>
              <div className="banner_cart_flx">
                {/* <figure>
                  <img src={imagePath.BannerUser} alt="" />
                </figure> */}
                <div className="banner_cart_r center_text">
                  {/* <p>Girips Technologies Expert</p> */}
                  <h3>Your Digital Partner</h3>
                </div>
              </div>
              <p className="bnner_tx">
                Turning your ideas into reliable and powerful digital solutions.
              </p>
            </div>
            <div className="banner_cart bnnr_btm">
              <span>
                <BannerArrowBtm />
              </span>
              <div className="banner_cart_flx">
                {/* <figure>
                  <img src={imagePath.BannerUser} alt="" />
                </figure> */}
                <div className="banner_cart_r">
                  {/* <p>Girips Technologies Expert</p> */}
                  <h3>Future-Ready Business</h3>
                </div>
              </div>
              <p className="bnner_tx">
                Looking to build the right digital product with the right team.
              </p>
            </div>
          </div>
        </div>
      </section>
      <HomeSecondSetion />
      <section className="why_sec">
        <div className="contair why_inr">
          <div className="heading">
            <h2>Why Choose Us?</h2>
            <p>
              We combine innovation, expertise, and a client-first approach to
              deliver scalable digital solutions that drive real business
              growth.
            </p>
          </div>
          <ul className="why_lst">
            <li className="why_bx">
              <CoreTeam />
              <h3>Highly Skilled</h3>
              <p>Experts providing secure and innovative digital solutions.</p>
            </li>

            <li className="why_bx">
              <Access />
              <h3>Modern Tech Stack</h3>
              <p>We leverage proven, scalable technologies — not trends.</p>
            </li>
            <li className="why_bx">
              <CustomizedSolutions />
              <h3>Customized Solutions</h3>
              <p>Tailored solutions for unique goals.</p>
            </li>
            <li className="why_bx">
              <HighEndServices />
              <h3>Performance Optimized</h3>
              <p>Speed, efficiency, and reliability engineered from day one.</p>
            </li>
            <li className="why_bx">
              <BusinessFocused />
              <h3>Business-Focused</h3>
              <p>Technology aligned with your business objectives.</p>
            </li>
            <li className="why_bx">
              <Budget />
              <h3>Cost-Effective</h3>
              <p>Affordable, top-quality IT solutions for every budget.</p>
            </li>
            <li className="why_bx">
              <ProfoundRD />
              <h3>Research & Strategy Driven</h3>
              <p>Research-driven development ensuring long-term advantage.</p>
            </li>
            <li className="why_bx">
              <AgileProcess />
              <h3>Fast & Agile</h3>
              <p>AAdaptive workflows enabling rapid and efficient delivery.</p>
            </li>
            <li className="why_bx">
              <OnTimeDelivery />
              <h3>On-Time Delivery</h3>
              <p>Committed to deadlines without compromising quality.</p>
            </li>
            <li className="why_bx">
              <CredibleSupport />
              <h3>Credible Support</h3>
              <p>Dependable support ensuring smooth operations.</p>
            </li>
            <li className="why_bx">
              <Expertise />
              <h3>Advanced Visualization</h3>
              <p>
                Data-rich visual interfaces that simplify complex information.
              </p>
            </li>
            <li className="why_bx">
              <ExtensiveMetaverse />
              <h3>Scalable Architecture</h3>
              <p>Infrastructure designed to grow with your business.</p>
            </li>
          </ul>
          <div className="btn_center">
            <button
              type="button"
              onClick={() => setIsPopupOpen(true)}
              className="btn_common btn_primry"
            >
              Hire Our Developer Now!
            </button>
          </div>
        </div>
      </section>
      <section className="our_sec">
        <div className="contair our_inr_flx">
          <div className="heading">
            <h2>Our Proven Path to Success</h2>
            <p>
              We follow a structured and result-driven process to accelerate
              your business growth and deliver long-term value.
            </p>
          </div>

          <div className="our_mn">
            <div className="our_bdr">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={size.width}
                height={size.height}
                viewBox="0 0 274 1303"
                fill="none"
              >
                <path
                  d="M74.5 1301L208.326 1129.31C292.146 1021.78 281.828 868.442 184.356 773.107C77.6758 668.765 77.7816 498.095 175.804 385.58C196.932 361.328 217.361 337.001 235.5 314C308.099 221.941 264.019 94.626 153.433 55.6857L0.971649 2"
                  stroke="url(#paint0_linear_57_275)"
                  strokeWidth="4"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_57_275"
                    x1="280"
                    y1="1270"
                    x2="151.432"
                    y2="1.71497"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#000001" />
                    <stop offset="0.333517" stopColor="#0397D0" />
                    <stop offset="0.675964" stopColor="#0397D0" />
                    <stop offset="1" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="our_inr our_one_bx">
              <div className="our_flx">
                <div className="our_bx common_border">
                  <h3>Understanding Your Business Needs</h3>
                  <ul>
                    <li>
                      <CircleCheck />{" "}
                      <span> Gather and analyze requirements</span>
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Define the solution approach</span>
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Create a clear project plan</span>
                    </li>
                  </ul>
                  <figure className="mng_img">
                    <img src={imagePath.Img1} alt="" />
                  </figure>
                </div>
                <div className="our_icon ">
                  {" "}
                  <Understanding />
                </div>
              </div>
            </div>
            <div className="our_inr our_scnd_bx">
              <div className="our_flx">
                <div className="our_bx common_border">
                  <h3>Designing the Technical Blueprint</h3>
                  <ul>
                    <li>
                      <CircleCheck />
                      <span> Map data flow and system design</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />{" "}
                      <span>Select the right technology stack</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />{" "}
                      <span>Build a detailed architecture blueprint</span>{" "}
                    </li>
                  </ul>
                  <figure className="mng_img">
                    <img src={imagePath.Img2} alt="" />
                  </figure>
                </div>
                <div className="our_icon">
                  <Conceptualizing />
                </div>
              </div>
            </div>
            <div className="our_inr our_thr_bx">
              <div className="our_flx">
                <div className="our_bx common_border">
                  <h3>Development & Implementation</h3>
                  <ul>
                    <li>
                      <CircleCheck />
                      <span> Write clean, scalable code</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span>
                        {" "}
                        Develop backend services and integrations
                      </span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Optimize the platform for performance</span>{" "}
                    </li>
                  </ul>
                  <figure className="mng_img">
                    <img src={imagePath.Img3} alt="" />
                  </figure>
                </div>
                <div className="our_icon">
                  <ProjectDevelopment />
                </div>
              </div>
            </div>
            <div className="our_inr our_inr_fr">
              <div className="our_flx">
                <div className="our_bx common_border">
                  <h3>Quality Testing & Validation</h3>
                  <ul>
                    <li>
                      <CircleCheck />
                      <span> Conduct thorough testing and audits</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Fix issues and refine performance</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Ensure a smooth product launch</span>{" "}
                    </li>
                  </ul>
                  <figure className="mng_img">
                    <img src={imagePath.Img4} alt="" />
                  </figure>
                </div>
                <div className="our_icon">
                  <RigorousTesting />
                </div>
              </div>
            </div>
            <div className="our_inr our_inr_five">
              <div className="our_flx">
                <div className="our_bx common_border">
                  <h3>Ongoing Support & Maintenance</h3>
                  <ul>
                    <li>
                      <CircleCheck />
                      <span> Provide reliable technical support</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span> Deliver timely updates and enhancements</span>{" "}
                    </li>
                    <li>
                      <CircleCheck />
                      <span>
                        {" "}
                        Ensure continuous quality and performance
                      </span>{" "}
                    </li>
                  </ul>
                  <figure className="mng_img">
                    <img src={imagePath.Img5} alt="" />
                  </figure>
                </div>
                <div className="our_icon">
                  <TechnicalMaintenance />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="next_sec">
        <div className="contair ">
          <div className="next_heading">
            <h3>
              <StartIocn />
              Services
            </h3>
            <h2>Next-Gen Solutions for Tomorrow’s Businesses</h2>
            <p>
              Our services drive digital transformation, streamline workflows,
              and position businesses ahead of their competitors.
            </p>
          </div>
          <div className="next_inr">
            <div className="next_l">
              <ul className="next_list">
                {services.map((service, index) => (
                  <li
                    key={index}
                    className={`next_link ${
                      activeIndex === index ? "active" : ""
                    }`}
                    onClick={() => handleClick(index)}
                  >
                    <Link className="hrf_link" to="">
                      <span>{service.icon} </span> {service.title}
                    </Link>
                    {/* <div className="next_r_innr">
                      <figure className="next_img">
                        <img
                          src={activeService.image}
                          alt={activeService.title}
                        />
                        <figcaption>{activeService.description}</figcaption>
                      </figure>

                      <ul className="next_r_hrf">
                        {activeService.links.map((link, i) => (
                          <li key={i} className="next_r_list">
                            <Link to={`/services/${link.slug}`}>
                              {link.link}
                            </Link>
                          </li>
                        ))}
                      </ul>
                      <ul className="next_icon">
                        {activeService.icons.map((ic, i) => (
                          <li key={i}>
                            <Link to={``} className="next_icon_list">
                              <span>{ic.icon}</span>
                              <h4>{ic.name}</h4>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div> */}
                  </li>
                ))}
              </ul>
            </div>
            <div className="next_r">
              <div className="next_r_innr">
                <figure className="next_img">
                  <img src={activeService.image} alt={activeService.title} />
                  <figcaption>{activeService.description}</figcaption>
                </figure>

                <ul className="next_r_hrf">
                  {activeService.links.map((link, i) => (
                    <li key={i} className="next_r_list">
                      <Link to={`/services/${link.slug}`}>{link.link}</Link>
                    </li>
                  ))}
                </ul>
                <ul className="next_icon">
                  {activeService.icons.map((ic, i) => (
                    <li key={i}>
                      <Link
                        to={`/services/${ic.name}`}
                        className="next_icon_list"
                      >
                        <span>{ic.icon}</span>
                        <h4>{ic.name}</h4>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="stack_sec">
        <div className="contair stack_inr">
          <div className="heading">
            <h2>Technology Stack</h2>
            <p>
              We build durable, high-quality web and mobile apps using advanced
              technologies, following best practices to align with your business
              goals.
            </p>
          </div>
          <ul className="stack_list">
            <Swiper
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              navigation={false}
              pagination={false}
              keyboard={true}
              slidesPerView="auto"
              freeMode={true}
              spaceBetween={0}
              grabCursor={true}
              breakpoints={{}}
              className="mySwiper1"
            >
              {/* stack_slt */}
              {stackItems.map((item, index) => (
                <SwiperSlide
                  style={{ width: "auto" }}
                  className={`stack_link ${
                    selectTechStackItem == item ? "stack_slt" : ""
                  }`}
                  onClick={() => setSelectTechStackItem(item)}
                >
                  <Link to="" className="stack_hrf">
                    {item}
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </ul>

          <Swiper
            modules={[Navigation, Pagination, Mousewheel, Keyboard]}
            navigation={false}
            pagination={false}
            // mousewheel={true}
            keyboard={true}
            spaceBetween={0}
            slidesPerView={6}
            grabCursor={true}
            breakpoints={{
              320: {
                slidesPerView: 3,
                spaceBetween: 6,
              },

              992: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 5,
              },
              1280: {
                slidesPerView: 6,
              },
            }}
            className="stack_icon_mn"
          >
            {getTechChildStackItems().map((stack, index) => (
              <SwiperSlide className="stack_icon_inr">
                <span> {stack.icon} </span>
                <h4>{stack.title}</h4>
              </SwiperSlide>
            ))}
          </Swiper>
          {/* <div className="stack_icon_mn">
            <div className="stack_icon_inr">
              <span> <CSS /> </span>
              <h4>CSS3</h4>
            </div>
            <div className="stack_icon_inr">
              <span> <ReactNativeIcon /> </span>
              <h4>React JS</h4>
            </div>
            <div className="stack_icon_inr">
              <span><Vuejs />  </span>
              <h4>Vue.js</h4>
            </div>
            <div className="stack_icon_inr">
              <span> <Angular /> </span>
              <h4>Angular JS</h4>
            </div>
            <div className="stack_icon_inr">
              <span> <Javascript /> </span>
              <h4>Javascript</h4>
            </div>
            <div className="stack_icon_inr">
              <span> <Html /> </span>
              <h4>Html5</h4>
            </div>
          </div> */}
        </div>
      </section>
      {/* <section className="awards_sec">
        <div className="contair ">
          <div className="heading">
            <h2>Awards and Reviews.</h2>
            <p>Proudly recognized with industry awards and trusted client reviews that reflect our commitment to excellence, innovation, and customer success.</p>
          </div>
          <div className="awards_inr">
            <Swiper
              navigation={false}
              pagination={false}

              keyboard={true}
              slidesPerView={4}
              spaceBetween={32}
              grabCursor={true}
              centeredSlides={false}
              breakpoints={{


                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3,
                },
                1280: {
                  slidesPerView: 4,
                },
              }}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="mySwiper2"
            >
              {awardsData.map((award, index) => (
                <SwiperSlide key={index}>
                  <div className="awards_list common_border">
                    <figure className="awards_img">
                      <img src={award.img} alt={award.title} />
                    </figure>
                    <h3>{award.title} <span className="blk">{award.titlebr}</span></h3>
                    <p>{award.subtitle}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </section> */}
      <section className="eng_sec">
        <div className="contair ">
          <div className="next_heading">
            <h3>
              <StartIocn />
              Industries
            </h3>
            <h2>Engineering Industry-Specific Excellence with Innovation</h2>
            <p>
              We provide digital solutions that drive innovation and growth
              across industries like healthcare, real estate, education and
              more.
            </p>
          </div>
          <div className="stack_list">
            <Swiper
              navigation={false}
              pagination={false}
              // mousewheel={true}
              keyboard={true}
              // slidesPerView={5}
              spaceBetween={0}
              grabCursor={true}
              slidesPerView="auto"
              freeMode={true}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="mySwiper3"
            >
              {/* stack_slt */}
              {EngineeringData.map((item, index) => (
                <SwiperSlide
                  key={`industry_${index}`}
                  style={{ width: "auto" }}
                  className={`stack_link ${
                    selectEngItem?.id == item?.id ? "stack_slt" : ""
                  }`}
                  onClick={() => setSelectEngItem(item)}
                >
                  {" "}
                  <Link to="" className="stack_hrf">
                    <span className="blk eng_icon">{<item.icon />}</span>
                    {item.title}
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className="eng_btm">
            <div className="next_r_innr">
              <figure
                className="eng_img"
                style={{
                  backgroundImage: `url(${selectEngItem.image})`,
                }}
              >
                {/* <img src={selectEngItem.image} alt="" /> */}
                <div className="caption">
                  {selectEngItem.title !== "" && (
                    <h3>{selectEngItem.subtitle}</h3>
                  )}
                  <figcaption>{selectEngItem.description}</figcaption>
                  <ul>
                    {selectEngItem.highlights.map((item, index) => (
                      <li key={`industry_high_${index}`}>
                        {" "}
                        <span>
                          <CircleCheck />
                        </span>{" "}
                        <span> {item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </figure>
            </div>
            <div className="btn_center">
              <button
                type="button"
                onClick={() => setIsPopupOpen(true)}
                className="btn_common btn_primry"
              >
                Let’s Connect!
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <section className="succes_sec">
        <div className="contair ">
          <div className="heading">
            <h2>Success Stories From Our Clients.</h2>
            <p>Girips Technologies is committed to delivering top-quality digital solutions through a
              strategic approach that guarantees customer delight and lasting relationships.</p>
          </div>
          <div className="succes_inr">
            <Swiper
              cssMode={true}
              navigation={true}
              pagination={true}
              // mousewheel={true}
              keyboard={true}
              slidesPerView={1}
              grabCursor={true}
              spaceBetween={0}
              modules={[Navigation, Pagination, Mousewheel, Keyboard]}
              className="success_slider"
            >
              <SwiperSlide>
                <div className="succes_sldr">
                  <figure className="success_img">
                    <img src={imagePath.ReviewImg} alt="" />
                  </figure>
                  <div className="succes_r">
                    <div className="succes_icon">
                      <span> <CallIcon /></span> <span className="review">
                        <StarReview />
                        <StarReview />
                        <StarReview />
                        <StarReview />
                        <StarReview />

                      </span>
                    </div>
                    <p>We were impressed by Girips Tech’s design and development capabilities.
                      The app they built not only looks amazing but has improved our customer
                      engagement significantly.</p>
                    <h3>John Smith</h3>
                    <em>Founder & CEO Valormind</em>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="succes_sldr">
                  <figure className="success_img">
                    <img src={imagePath.ReviewImg} alt="" />
                  </figure>
                  <div className="succes_r">
                    <div className="succes_icon">
                      <span> <CallIcon /></span> <span className="review">
                        <StarReview />
                        <StarReview />
                        <StarReview />
                        <StarReview />
                        <StarReview />

                      </span>
                    </div>
                    <p>We were impressed by Girips Tech’s design and development capabilities.
                      The app they built not only looks amazing but has improved our customer
                      engagement significantly.</p>
                    <h3>John Smith</h3>
                    <em>Founder & CEO Valormind</em>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>

      </section> */}
      {/* <LatestNews /> */}

      <ContactUs isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}
